module.exports = __webpack_public_path__ + "img/ic-dropdown-low.57959c96.svg";